// extracted by mini-css-extract-plugin
export default {"folded-cover-top":"FoldedCoverTopBackground_folded-cover-top__266gh"};